import { gql } from '@apollo/client';

export const GET_ORDER_CANCEL_TASKS = gql`
    query GetPortalOrderCancelTasks($page: Int, $size: Int) {
        portalOrderCancelTasks(page: $page, size: $size) {
            content {
                id
                sourceFileName
                sourceFileSize
                status
                totalCount
                successCount
                failedCount
                ignoredCount
                createdAccountNumber
                createdAt
                updatedAt
                completedAt
            }
            totalElements
            totalPages
            page
            size
        }
    }
`;

export const GET_ORDER_CANCEL_TASK_DETAILS = gql`
    query GetPortalOrderCancelTaskDetails($taskId: ID!, $page: Int, $size: Int) {
        portalOrderCancelTaskDetails(taskId: $taskId, page: $page, size: $size) {
            content {
                id
                taskId
                trackingNumber
                rowNumber
                status
                failureReason
                failureMessageKey
                apiServerStatus
                startedAt
                completedAt
            }
            totalElements
            totalPages
            page
            size
        }
    }
`;
